import { atom } from "recoil";

export const daAddState = atom({
  key: "daAddState",
  default: false,
});
export const daEditState = atom({
  key: "daEditState",
  default: false,
});
export const getDigitalAssetsOpt = atom({
  key: "getDigitalAssetOpt",
  default: [],
});
export const setRowForEditDigitalAsset = atom({
  key: "setRowForEditDigitalAsset",
  default: {},
});

export const selectedRowsStateDigitalAssets = atom({
  key: "selectedRowsStateDigitalAssets",
  default: [],
});

export const daFromOffice = atom({
  key: "daFromOffice",
  default: false,
});

export const daShowState = atom({
  key: "daShowState",
  default: false,
});
export const daViewData = atom({
  key: "daViewData",
  default: [],
});

export const confirmSaveDA = atom({
  key: "confirmSaveDA",
  default: false,
});

export const showFromNotifDA = atom({
  key: "showFromNotifDA",
  default: false,
});

export const showFromNotifViewDA = atom({
  key: "showFromNotifViewDA",
  default: false,
});

export const daOfficeData = atom({
  key: "daOfficeData",
  default: [],
});
